import React__default from 'react';
import styled from '../../../node_modules/@mui/material/styles/styled.js';
import TooltipComponent from '../../../node_modules/@mui/material/Tooltip/Tooltip.js';
import tooltipClasses from '../../../node_modules/@mui/material/Tooltip/tooltipClasses.js';

const LightTooltip = styled(({ className, ...props }) => (React__default.createElement(TooltipComponent, { ...props, classes: { popper: className } })))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: '#fafafa',
        '&::before': {
            backgroundColor: '#fafafa',
            border: '1px solid #999',
        },
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fafafa',
        color: 'rgba(0, 0, 0, 0.9)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
        minHeight: 25,
    },
}));
/**/
const DarkTooltip = styled(({ className, ...props }) => (React__default.createElement(TooltipComponent, { ...props, classes: { popper: className } })
// eslint-disable-next-line @typescript-eslint/no-unused-vars
))(({ theme }) => ({}));
const returnTitleNode = (tit) => {
    let lines = tit.split('\n');
    if (lines.length < 2)
        lines = tit.split('\\n');
    return (React__default.createElement(React__default.Fragment, null, lines.map((line, index) => (React__default.createElement(React__default.Fragment, { key: index },
        line,
        index !== lines.length - 1 && React__default.createElement("br", null))))));
};
function handleTitle(tit) {
    if (typeof tit === 'string') {
        return returnTitleNode(tit);
    }
    else if (React__default.isValidElement(tit) &&
        typeof tit.props.children === 'string') {
        returnTitleNode(tit.props.children);
    }
    else {
        return tit;
    }
}
const Tooltip = ({ children, title, placement = 'top', arrow = true, color = 'dark', followCursor = false, maxWidth, disableInteractive = true, }) => {
    const TooltipComponentToUse = color === 'light' ? LightTooltip : DarkTooltip;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(TooltipComponentToUse, { sx: { maxWidth: maxWidth }, title: handleTitle(title), placement: placement, arrow: arrow, followCursor: followCursor, disableInteractive: disableInteractive }, children)));
};

export { Tooltip as default };
//# sourceMappingURL=Tooltip.js.map
